export default function BarraProgresso({ pct, altura = 8 }) {
  const v = Math.max(0, Math.min(100, pct || 0));
  return (
    <div className="barra-prog" style={{ height: altura }}>
      <div className={`barra-prog-fill${v === 100 ? ' barra-prog-fill--ok' : ''}`} style={{ width: `${v}%` }} />
    </div>
  );
}
